/* istanbul ignore file */

import { batch, connect } from 'react-redux';

import { actions as filterActions } from 'src/components/organisms/Filter/modules/slice';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectFilterOptions, selectSelectedFilterOptions } from 'src/redux/products/selectors';
import type { AppThunkDispatch } from 'src/redux/store';
import type { SelectedFilterOption } from 'src/types';
import {
  updateFilters,
  UpdateFiltersActionType,
} from '../../../../redux/products/thunks/updateFilters';
import type { QuickFiltersProps } from '../components/QuickFilters';
import { QuickFilters } from '../components/QuickFilters';

const mapStateToProps = (state: ReduxApplicationState, ownProps: QuickFiltersProps) => ({
  filterLinks: selectFilterOptions(state, ownProps.filterUid),
  selectedFilterOptions: selectSelectedFilterOptions(state, ownProps.filterUid),
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onSelectFilterOption: (selectedFilterOption: SelectedFilterOption) => {
    batch(() => {
      dispatch(filterActions.selectFilterOption(selectedFilterOption));
      dispatch(updateFilters(UpdateFiltersActionType.FILTER));
    });
  },
});

export const QuickFiltersContainer = connect(mapStateToProps, mapDispatchToProps)(QuickFilters);
